/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EnrollmentUpdateModel } from '../models';
// @ts-ignore
import type { GetProviderPayerMeta200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PayerAddModel } from '../models';
// @ts-ignore
import type { PayerAdminModel } from '../models';
// @ts-ignore
import type { PayerMaintenanceResponse } from '../models';
// @ts-ignore
import type { PayerStatus } from '../models';
// @ts-ignore
import type { PayerUpdateModel } from '../models';
// @ts-ignore
import type { ProviderPayerMetaPatchModel } from '../models';
// @ts-ignore
import type { ProviderSearchModel } from '../models';
// @ts-ignore
import type { TransactionType } from '../models';
/**
 * PayersApi - axios parameter creator
 * @export
 */
export const PayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayerMaintenance: async (payerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getPayerMaintenance', 'payerId', payerId)
            const localVarPath = `/api/v1/payer/{payerId}/maintenance`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<PayerStatus>} [status] 
         * @param {Array<TransactionType>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayers: async (status?: Array<PayerStatus>, transactions?: Array<TransactionType>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (transactions) {
                localVarQueryParameter['transactions'] = transactions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPayerMeta: async (payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getProviderPayerMeta', 'payerId', payerId)
            // verify required parameter 'providerSearchModel' is not null or undefined
            assertParamExists('getProviderPayerMeta', 'providerSearchModel', providerSearchModel)
            const localVarPath = `/api/v1/payer/{payerId}/providers`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (allProviders !== undefined) {
                localVarQueryParameter['allProviders'] = allProviders;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<PayerUpdateModel>} payerUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPayer: async (payerUpdateModel: Array<PayerUpdateModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerUpdateModel' is not null or undefined
            assertParamExists('patchPayer', 'payerUpdateModel', payerUpdateModel)
            const localVarPath = `/api/v1/payer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payerUpdateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProviderPayerMeta: async (payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('patchProviderPayerMeta', 'payerId', payerId)
            // verify required parameter 'providerPayerMetaPatchModel' is not null or undefined
            assertParamExists('patchProviderPayerMeta', 'providerPayerMetaPatchModel', providerPayerMetaPatchModel)
            const localVarPath = `/api/v1/payer/{payerId}/providers`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerPayerMetaPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PayerAddModel} payerAddModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPayer: async (payerAddModel: PayerAddModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerAddModel' is not null or undefined
            assertParamExists('postPayer', 'payerAddModel', payerAddModel)
            const localVarPath = `/api/v1/payer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payerAddModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnrollment: async (payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('updateEnrollment', 'payerId', payerId)
            // verify required parameter 'enrollmentUpdateModel' is not null or undefined
            assertParamExists('updateEnrollment', 'enrollmentUpdateModel', enrollmentUpdateModel)
            const localVarPath = `/api/v1/payer/{payerId}/providers/enrollment`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollmentUpdateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayersApi - functional programming interface
 * @export
 */
export const PayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayerMaintenance(payerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayerMaintenanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayerMaintenance(payerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.getPayerMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<PayerStatus>} [status] 
         * @param {Array<TransactionType>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayers(status?: Array<PayerStatus>, transactions?: Array<TransactionType>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayerAdminModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayers(status, transactions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.getPayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPayerMeta(payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProviderPayerMeta200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPayerMeta(payerId, providerSearchModel, allProviders, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.getProviderPayerMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<PayerUpdateModel>} payerUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPayer(payerUpdateModel: Array<PayerUpdateModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPayer(payerUpdateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.patchPayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchProviderPayerMeta(payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchProviderPayerMeta(payerId, providerPayerMetaPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.patchProviderPayerMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PayerAddModel} payerAddModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPayer(payerAddModel: PayerAddModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayerAdminModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPayer(payerAddModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.postPayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnrollment(payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnrollment(payerId, enrollmentUpdateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.updateEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayersApi - factory interface
 * @export
 */
export const PayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayerMaintenance(payerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerMaintenanceResponse>> {
            return localVarFp.getPayerMaintenance(payerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<PayerStatus>} [status] 
         * @param {Array<TransactionType>} [transactions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayers(status?: Array<PayerStatus>, transactions?: Array<TransactionType>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerAdminModel>> {
            return localVarFp.getPayers(status, transactions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} payerId 
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPayerMeta(payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetProviderPayerMeta200Response> {
            return localVarFp.getProviderPayerMeta(payerId, providerSearchModel, allProviders, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<PayerUpdateModel>} payerUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPayer(payerUpdateModel: Array<PayerUpdateModel>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchPayer(payerUpdateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProviderPayerMeta(payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchProviderPayerMeta(payerId, providerPayerMetaPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayerAddModel} payerAddModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPayer(payerAddModel: PayerAddModel, options?: RawAxiosRequestConfig): AxiosPromise<PayerAdminModel> {
            return localVarFp.postPayer(payerAddModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnrollment(payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEnrollment(payerId, enrollmentUpdateModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayersApi - interface
 * @export
 * @interface PayersApi
 */
export interface PayersApiInterface {
    /**
     * 
     * @param {string} payerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    getPayerMaintenance(payerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerMaintenanceResponse>>;

    /**
     * 
     * @param {Array<PayerStatus>} [status] 
     * @param {Array<TransactionType>} [transactions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    getPayers(status?: Array<PayerStatus>, transactions?: Array<TransactionType>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerAdminModel>>;

    /**
     * 
     * @param {string} payerId 
     * @param {ProviderSearchModel} providerSearchModel 
     * @param {boolean} [allProviders] 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    getProviderPayerMeta(payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetProviderPayerMeta200Response>;

    /**
     * 
     * @param {Array<PayerUpdateModel>} payerUpdateModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    patchPayer(payerUpdateModel: Array<PayerUpdateModel>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} payerId 
     * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    patchProviderPayerMeta(payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PayerAddModel} payerAddModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    postPayer(payerAddModel: PayerAddModel, options?: RawAxiosRequestConfig): AxiosPromise<PayerAdminModel>;

    /**
     * 
     * @param {string} payerId 
     * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    updateEnrollment(payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PayersApi - object-oriented interface
 * @export
 * @class PayersApi
 * @extends {BaseAPI}
 */
export class PayersApi extends BaseAPI implements PayersApiInterface {
    /**
     * 
     * @param {string} payerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public getPayerMaintenance(payerId: string, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).getPayerMaintenance(payerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<PayerStatus>} [status] 
     * @param {Array<TransactionType>} [transactions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public getPayers(status?: Array<PayerStatus>, transactions?: Array<TransactionType>, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).getPayers(status, transactions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} payerId 
     * @param {ProviderSearchModel} providerSearchModel 
     * @param {boolean} [allProviders] 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public getProviderPayerMeta(payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).getProviderPayerMeta(payerId, providerSearchModel, allProviders, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<PayerUpdateModel>} payerUpdateModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public patchPayer(payerUpdateModel: Array<PayerUpdateModel>, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).patchPayer(payerUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} payerId 
     * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public patchProviderPayerMeta(payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).patchProviderPayerMeta(payerId, providerPayerMetaPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayerAddModel} payerAddModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public postPayer(payerAddModel: PayerAddModel, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).postPayer(payerAddModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} payerId 
     * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public updateEnrollment(payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).updateEnrollment(payerId, enrollmentUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }
}

